import React, { useState } from 'react'
import FormValidator from './FormValidators/FormValidator'
import { Link, useNavigate } from 'react-router-dom'
import Navbar from './Partial/Navbar';

export default function Login() {
    let navigate = useNavigate();
    let [showPassword, setShowPassword] = useState(false)
    let [data, setData] = useState({
        username: "",
        password: ""


    })
    let [errorMessage, setErrorMessage] = useState({
        username: "UserName is Mendetory",
    })

    let [show, setShow] = useState(false)
    let [message, setMessage] = useState("")

    const visiblePassword = () => {
        setShowPassword(!showPassword)
    }

    function getInputData(e) {
        let { name, value } = e.target
        setMessage("")
        if (name !== "password") {
            setErrorMessage((old) => {
                return {
                    ...old,
                    [name]: FormValidator(e)
                }
            })
        }

        setData((old) => {
            return {
                ...old,
                [name]: value
            }
        })

    }

    async function postData(e) {
        e.preventDefault();
        let error = Object.values(errorMessage).find((x) => x !== "");
        if (error) {
            setShow(true);
        } else {
            let response = await fetch("/api/user/login", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify(data),
            });

            response = await response.json();

            if (response.result === "Done") {
                localStorage.setItem("login", true);
                localStorage.setItem("name", response.data.name);
                localStorage.setItem("userid", response.data._id);
                localStorage.setItem("role", response.data.role);
                localStorage.setItem("token", response.token);

                if (response.data.role === "Buyer") {
                    navigate("/");
                } else {
                    navigate("/admin");
                }
                window.location.reload();
            } else {
                setShow(true);
                setMessage("Invalid Username or Password");
            }
        }
    }

    return (
        <>
            <Navbar />
            <div className="d-flex justify-content-center align-items-center background">
                <div className="card card-respon p-2 login-box mt-5">
                    <div className="card-body" >
                        <h2 className='text-center text-dark'><span className='text-info'>Mini</span>Store</h2>
                        <h6 className="card-title text-center border-bottom border-2 p-2">Login With Your Account</h6>
                        <form onSubmit={postData}>
                            <div className="row">
                                <div className="mt-3">
                                    <label className='text-info'>Username</label>
                                    <input type="text" name="username" onChange={getInputData} className={`form-control border-2 ${show && errorMessage.username ? "border-danger" : "border-dark"} w-100`} placeholder='Username Or Email' />
                                    {show && errorMessage.username ? <p className='text-danger'>{errorMessage.username}</p> : ""}
                                    {show && message ? <p className='text-danger'>{message}</p> : ""}
                                </div>
                                <div className="mt-3 position-relative">
                                    <label className="text-info">Password</label>
                                    <div className="position-relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            onChange={getInputData}
                                            className={`form-control border-2 ${show && errorMessage.password ? "border-danger" : "border-dark"} w-100`}
                                            placeholder="Password"
                                        />
                                        <i
                                            className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                                            onClick={visiblePassword}
                                            style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
                                        ></i>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-end'>
                                    <Link to="/otp-sender" className='text-dark mt-2 border-bottom' style={{ fontSize: "14px" }}>Forget Password</Link>
                                </div>
                            </div>

                            <div>
                                <button type="submit" className='btn btn-info border-2 w-100 mt-4'>Log-In</button>
                            </div>
                            <div className='mt-2'>
                                <Link to="/signup" className='text-dark' style={{ fontSize: "14px" }}>Don't Have Account?<span className='text-info'>Sign-Up</span></Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}
